<template>
	<v-card>
		<v-card-title class="blue darken-2">
    <h1 class="white--text">
      <span class="botter-facebook-icon"></span>
      Facebook App Config
    </h1>
    </v-card-title>
    <v-card-text>
      <v-form>
      <label>Name</label>
      <v-text-field
        v-model = "input.name"
        placeholder="Name"
        outline />
      <label>Page Id</label>
      <v-text-field
        v-model = "input.page_id"
        placeholder="Page Id"
        outline />
      <label>Image</label>
      <v-text-field
        v-model = "input.image"
        placeholder="Image"
        outline />
      <v-img v-if = "input.image && input.image.length" :src="input.image" max-height="100" max-width="100"/>
      <label>Access Token</label>
      <v-text-field
        v-model = "input.access_token"
        placeholder="Access Token"
        outline />
      <label>Verify Token</label>
      <v-text-field
        v-model = "input.verify_token"
        placeholder="Verify Token"
        outline />
      <label>App Secret</label>
      <v-text-field
        v-model = "input.app_secret"
        placeholder="App Secret"
        outline />
    </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('closed')">Close</v-btn>
      <v-btn class="blue darken-2 white--text" @click="updateApp">Save</v-btn>
    </v-card-actions>
	</v-card>
</template>

<script>
export default {

  name: 'FacebookNotificationsConfig',
  props: {
  	pageId: {
  		type: String,
  		required: true
  	}
  },
  data () {
    return {
    	appData: null,
      input: {
        name: '',
        page_id: '',
        image: '',
        access_token: '',
        verify_token: '',
        app_secret: '',
      }
    }
  },
  computed: {
  	botId() {
  		return this.$store.state.bot.botId
  	}
  },
  mounted() {
  	this.getApp()
  },
  methods: {
  	getFacebookApps() {
  		this.getApps()
  	},
  	async getApp() {
      this.$store.dispatch('setLoader', true)
  		this.$http_chat.get(`/bots/apps/facebook/${this.pageId}`).then(({ data }) =>{
        this.$store.dispatch('setLoader', false)
        if(data.facebook_apps && data.facebook_apps.length) {
          this.appData = data.facebook_apps[0]
          this.input = data.facebook_apps[0]
        } else {
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        }
      }).catch(()=>{
        this.$store.dispatch('setErrorMessage', true)
        this.$store.dispatch('setLoader', false)
      })
  	},
    updateApp() {
      this.$store.dispatch('setLoader', true)
      const payload = this.$_.omit(this.input, ['_id'])
      this.$http_chat.put(`/bots/${this.botId}/apps/facebook`, payload).then(({ data })=>{
        this.$store.dispatch('setSnackbar', {
            text: `Updated Successfully`,
            color: 'success'
          })
          this.$store.dispatch('setLoader', false)
          this.$emit('success', data)
      }).catch(()=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>